import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";
import { IFilterSlice, createFilterSlice } from "./FilterSlice";
import { IMapSlice, createMapSlice } from "./MapSlice";
import { IPopupSlice, createPopupSlice } from "./PopupSlice";
import { ICacheSlice, createCacheSlice } from "./cacheSlice";
import {
  INotificationSlice,
  createNotificationSlice,
} from "./NotificationSlice";

export interface IStore
  extends IFilterSlice,
    IPopupSlice,
    IMapSlice,
    INotificationSlice,
    ICacheSlice {}

export const useNitroStore = create(
  subscribeWithSelector<IStore>((set: any, get: any) => ({
    ...createFilterSlice(set, get),
    ...createMapSlice(set, get),
    ...createPopupSlice(set, get),
    ...createNotificationSlice(set, get),
    ...createCacheSlice(set, get),
  }))
);
